<template>
  <footer class="app-footer">
    <span><a target="blank" href="https://www.infracommerce.lat/">Infracommerce</a> &copy; {{currentDate.getFullYear()}}.</span>
  </footer>
</template>
<script>
export default {
  name: 'footer-sc',
  data () {
    return {
      currentDate: new Date()
    }
  }
}
</script>
